import Select from '@components/v2/form/Select/Select';
import { SelectOption } from '@components/v2/form/Select/select.types';
import { findOptionLabel } from '@components/v2/form/Select/select.utils';
import { Control, Controller } from 'react-hook-form';
import { ExportOrderForm } from '../ExportOrderModal.types';

type ExportOrderSelectName = keyof Pick<
  ExportOrderForm,
  'exportType' | 'pageOrientation' | 'exportModel' | 'groupBy' | 'sortBy' | 'csvTemplate'
>;

interface ExportOrderSelectFieldProps {
  control: Control<ExportOrderForm>;
  name: ExportOrderSelectName;
  label: string;
  options: SelectOption[];
  disabled?: boolean;
}

const ExportOrderSelectField = ({
  control,
  name,
  label,
  options,
  disabled,
}: ExportOrderSelectFieldProps) => (
  <Controller
    control={control}
    name={name}
    render={({ field }) => (
      <Select
        size="small"
        name={field.name}
        label={label}
        value={field.value ?? ''}
        options={options}
        disabled={disabled}
        onBlur={field.onBlur}
        onChange={field.onChange}
        renderValue={(selected) => findOptionLabel(options, String(selected))}
      />
    )}
  />
);

export default ExportOrderSelectField;
